// import * as types from './mutations-types'

const mutations = {
  SET_SIDEBAR(state, data) {
    state.sidebar = data
  },
  // alert
  SET_ALERT_DATA(state, data) {
    state.alertData = data
  },
  SET_ALERT_DATA_TYPE(state, type) {
    let alertData = state.alertData
    alertData.type = type
    state.alertData = alertData
  },
  SET_ALERT_DATA_SHOW(state, show) {
    let alertData = state.alertData
    alertData.show = show
    state.alertData = alertData
  },
  SET_NAVBAR_ACTION(state, data) {
    state.navbarAction = data
  },
  set_SIDEBAR_NUM(state, data) {
    state.sidebarNum = data
  },
  HAS_COVERLETTER(state, data) {
    state.has_coverletter = data
  },
  IS_DOUBLE(state, data) {
    state.isDouble = data;
  },
  updateOssOptions(state, data) {
    state.updateOssOptions = data;
  },
}

export default mutations
